import React from 'react'
import { AppBar, IconButton, Toolbar, Typography } from '@material-ui/core';
import { useLocation } from "react-router-dom";
import useOnlineStatus from '../hooks/useOnlineStatus'
import OfflineIcon from '@material-ui/icons/SignalWifiOff';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import MenuIcon from '@material-ui/icons/Menu';

const Header = ({ title, backAction, menuAction, children }) => {
  const location = useLocation()
  const isOnline = useOnlineStatus()
  title = (title ?? location.pathname)
  if (process.env.REACT_APP_PROJECTID.match(/(57|62)/)) {
    title += ' | ' + process.env.REACT_APP_TITLE
  }

  return (
    <>
      <AppBar position="sticky">
        <Toolbar>
          {backAction &&
            <IconButton onClick={backAction} style={{ color: "#fff" }}>
              <ArrowBackIosIcon />
            </IconButton>
          }
          {menuAction &&
            <IconButton onClick={menuAction} style={{ color: "#fff" }}>
              <MenuIcon />
            </IconButton>
          }
          <Typography variant="h6" noWrap={true}>{title}</Typography>
          {!isOnline && <IconButton
            size="large"
            edge="end"
            aria-label="geen verbinding"
            color="inherit">
            <OfflineIcon />
          </IconButton>}
        </Toolbar>
      </AppBar>
      {children}
    </>
  )
}

export default Header
